import { Offcanvas, ListGroup } from "react-bootstrap";
import { FiCheck } from "react-icons/fi";
import { useState } from "react";
import { useEffect } from "react";
import { propertyServices } from "../../../APIServices/GlobalManagements/propertyServices";
import { userServices } from "../../../APIServices/UserData/userServices";

const PropertyList = ({
  show,
  hide,
  title,
  getCurrectLoginUser,
  currentUserData
}) => {
  const [properties, setProperties] = useState([]);

  const getAccessPropertyList = async () => {
    let data = await propertyServices.getAccessPropertyList();
    setProperties(data?.data || []);
  };

  const switchLoginAccountAndProperty = async (propertyId) => {
    let userData = {};
    userData.loginPropertyId = propertyId;
    let data = await userServices.switchLoginAccountAndProperty(userData);
    if (data?.statusCode === 200) {
      getCurrectLoginUser();
      hide();
      window.location.reload();
    }
  };

  useEffect(() => {
    if (currentUserData)
      getAccessPropertyList();
  }, [currentUserData]);

  return (
    <Offcanvas show={show} onHide={hide} className="property-canvas">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <ListGroup variant="flush">
          {properties?.map((item) => (
            <ListGroup.Item
              key={item.id}
              action
              onClick={() => {
                if (!item.loginStatus)
                  switchLoginAccountAndProperty(item.propertyId);
              }}
              className={`d-flex justify-content-between align-items-center py-2 ${item.loginStatus
                ? "bg-success-subtle"
                : ""
                }`}
            >
              <div className="hstack gap-2">
                <img
                  src={item.icon || "https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png?width=40&height=40"}
                  alt={item.name}
                  className="me-2"
                  style={{ width: 30, height: 30, objectFit: "contain" }}
                />
                <div>
                  <div className="fw-semibold small">{item.name}</div>
                  <small className="text-muted">{item.domain}</small>
                </div>
              </div>

              {item.loginStatus && (
                <FiCheck size={18} className="text-success" />
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PropertyList;
